<template>
<section style="padding-bottom:69px;">   
    <swiper class="swiper model_slide" :options="swiperOption" >
        <!-- trimItem.atts -->
        <swiper-slide class="item" 
            v-for="(att,idx) in trimItem.atts" 
            :key="`vehicle-info-atts-item-${idx}`"
        >
            <div class="model_img"><img :src="att.url"></div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
    
    <div class="wrap">
        <div class="model_name_div">
            <img :src="trimItemModelAttUrl">
            <dl class="model_name">
                <dt>{{trimItem.name}}</dt>
                <!-- <dt>{{trimItem.content}}</dt> -->
            </dl>
        </div>
        <div class="model_detail">
            <!--<h4 class="title">상세정보</h4>-->
            <div class="contants">
                <div class="contants_pbox">
                    <table>
                        <thead>
                            <tr>
                                <th>연료타입</th>
                                <th>차종</th>
                                <th>배기량 (cc)</th>
                                <th>복합연비 (km/l)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{{$_getCodeDicData(trimItem.fuel)}}</td>
                                <td>{{$_getCodeDicData(trimItem.bodyStyle)}}</td>
                                <td>{{trimItem.displacement}} </td>
                                <td>{{trimItem.fuelEconomy}} </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <ReviewData
            v-if="Object.keys(trimItem).length"
            v-bind="trimItem.reviewScore"
            type-trim>
        </ReviewData>

        <ReviewList 
            :items="$store.state.review.items" 
            :totalCount="$store.state.review.totalCount"
            :to="`/vehicleReview/${trimItem.id}`">
        </ReviewList>

    </div>

    <button class="default_fixed_btn" @click="scSearch()">컨설턴트 찾기</button>
</section>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import ReviewData from '../../components/review/ReviewData.vue'
import ReviewList from '../../components/review/ReviewList.vue'

export default {
    name:'VehicleInfo',
    components:{
        ReviewData,
        ReviewList,
    },

    created () {
        this.getItem();
    },

    data() {
        return {
            swiperOption: {
                autoHeight: true, //enable auto height
                spaceBetween: 5, //거리
                pagination: {
                    el: '.swiper-pagination'
                }
            },

            trimItem: {
                atts:[],
            },
        }
    },

    computed: {
        ...mapState({
            brandItems: state => state.brand.items,
            // trimItem: state => state.trim.item,
            bookingWrite: state => state.booking.itemWrite,

            resource: state => state.resource,

            TRIM_FUEL: state => state.codeDictionary.items.TRIM_FUEL,
            TRIM_UNIT: state => state.codeDictionary.items.TRIM_UNIT,
        }),
        ...mapGetters([
            'viewModelAttUrl',
            'viewTrimAtts'
        ]),

        brandItem() {
            return this.branditems.find( brandItem => brandItem.id == this.trimItem.brand.id);
        },

        trimId() {
            return this.$route.params.trimId; 
        },

        trimItemModelAttUrl(){
            return this.viewModelAttUrl((this.trimItem.modelAtt) ? this.trimItem.modelAtt.url : null);
        },

        displacementUnit() {
            return (this.trimItem.fuel == this.TRIM_FUEL.ELECTRIC.id) ? this.TRIM_UNIT.PS.title : this.TRIM_UNIT.CC.title ;
        },
        fuelEconomyUnit() {
            return (this.trimItem.fuel == this.TRIM_FUEL.ELECTRIC.id) ? this.TRIM_UNIT.BEV.title : this.TRIM_UNIT.ICE.title ;
        },
    },
    methods: {

        async getItem() {

            await this.$store.dispatch('GET_TRIM', this.trimId)
            .then((data)=>{
                this.trimItem = data;
                this.vehicleAtts();
                this.setHeaderTitle();
                this.setRecentCars();
            })

            this.$store.commit('SHOW_ONLOAD');
            
            this.$store.dispatch('GET_REVIEW_LIST_PAGE', {
                trimId: this.trimId, 
                hasContent: 1, 
                page: 0, 
                size: 5
            });
        },
        
        setHeaderTitle() {
            this.$store.state.headerTitle = (this.trimItem) ? `${this.trimItem.brand.name} ${this.trimItem.model.name}` : '';
        },

        setRecentCars() {
            let oldRecentCars = JSON.parse(localStorage.getItem('userId-recentCars'));

            oldRecentCars = (oldRecentCars) ? oldRecentCars : []; 

            let idx = oldRecentCars.findIndex(e => e.id === this.trimItem.id);

            if(idx !== -1) oldRecentCars.splice(idx,1);

            let recentCar = {
                id:this.trimItem.id, 
                brandName: this.trimItem.brand.name,
                modelName: this.trimItem.model.name,
                trimName: this.trimItem.name,
                modelUrl: (this.trimItem.modelAtt) ? this.trimItem.modelAtt.url : this.resource.imgSampleModel,
            };

            let recentCars = [recentCar,...oldRecentCars];
            if(recentCars.length > 7) recentCars.pop();

            localStorage.setItem('userId-recentCars', JSON.stringify(recentCars));
        },

        vehicleAtts() {
            let atts = [];
            
            atts = this.trimItem.atts;

            if(atts == null || atts.length == 0) {
                if(this.trimItem.modelAtt)
                    atts.push(this.trimItem.modelAtt);
                else 
                    atts = this.viewTrimAtts(atts);
            }

            return atts;
        },

        scSearch() {
            this.bookingWrite.brandId = this.trimItem.brand.id;
            this.bookingWrite.brandName = this.trimItem.brand.name;
            this.bookingWrite.brandUrl = (this.trimItem.brandAtt) ? this.trimItem.brandAtt.url : '';

            this.bookingWrite.modelId = this.trimItem.model.id;
            this.bookingWrite.modelName = this.trimItem.model.name;
            this.bookingWrite.modelUrl = (this.trimItem.modelAtt) ? this.trimItem.modelAtt.url : '';

            this.bookingWrite.trimId = this.trimItem.id;
            this.bookingWrite.trimName = this.trimItem.name;

            this.$router.push(`/booking/inputBasic`);
        }
    },    
}
</script>

<style>
.free_book_data .title {
    display:none
}
</style>